/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Input,
  InputLabel,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Popup from 'reactjs-popup';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import React, { useState, useEffect } from 'react';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import moment from 'moment';
import Dropzone from 'react-dropzone';
import swal from 'sweetalert';
import myFirebase from '../../../../config/config';
import FeatureFlagEmptyState from '../../../Components/FeatureFlagEmptyState';
import { mappedCurrentActiveRole } from '../../../../utils/roleMapping';
import {
  deleteTransactionsFileHandler,
  fileUploaderNew,
  getTransactionsSignedURL,
  getTransactionsViewURL,
} from '../../../../utils/fileUploadHandler';
import { isEwayNumber } from '../../../../utils/regexValidator';
import apiCaller from '../../../../utils/apiCallerOutstanding';
import logger from '../../../../utils/logger';

const contentStyle = { width: '300px' };
const useStyles = makeStyles(theme => ({
  paper: { padding: '10px 20px', marginTop: 20 },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '2px dashed lightgray',
    borderRadius: '5px',
    margin: '14px 20px',
  },
  viewButton: {
    background: '#52BE56',
    color: 'white',
    padding: '5px 15px 5px 15px',
  },
  viewCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  viewCardMeta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  deleteModalButton: {
    width: '45%',
    background: '#52BE56',
    borderRadius: 0,
    color: 'white',
    margin: '5px',
  },
  cancelButton: {
    width: '45%',
    background: 'lightgray',
    borderRadius: 0,
    margin: '5px',
  },
  ewayNumberContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  ewayNumber: {
    margin: '0px',
    fontWeight: '400',
    fontSize: '16px',
  },
  rejectRemarks: {
    color: 'red',
    textAlign: 'left',
    fontSize: '12px',
  },
  submitButton: {
    background: '#3366FF',
    color: 'white',
    fontSize: '12px',
    textTransform: 'capitalize',
  },
}));
const inlineCheckIconStyle = {
  marginLeft: '10px',
  color: '#52BE56',
};
const detailsButton = {
  background: 'transparent',
  border: 'none',
  textDecoration: 'underline',
  color: 'blue',
  cursor: 'pointer',
  textTransform: 'none',
};
const EwayBillUpload = ({
  currentTransactionData,
  activeRole,
  stylesClass,
  featureFlagFiles,
}) => {
  const classes = useStyles();
  const [uploading, setUploading] = useState(false);
  const [uploadedURL, setUploadedUrl] = useState('');
  const [fileDetails, setFileDetails] = useState({});
  const [token, setToken] = useState('');
  const [isDeleting, setIsDeleting] = React.useState(false);
  const { transactionId } = currentTransactionData;
  const [ewayNumber, setEwayNumber] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [ewayBillDetails, setEwayBillDetails] = useState(null);
  const [loadingEwayDetails, setLoadingEwayDetails] = useState(false);
  const [ewayFile, setEwayFile] = useState(null);
  const [UpdatingEwayNum, setUpdatingEwayNum] = useState(false);

  const fetchEwayUrl = async () => {
    setUploading(true);
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'eway_bill',
      transaction_id: transactionId,
    };

    try {
      const response = await getTransactionsViewURL(body);
      setUploadedUrl(response?.data?.file_details?.url ?? '');
      setFileDetails(response?.data?.file_details);
      if (response?.data?.file_details?.status === 'rejected') {
        setEwayNumber(response?.data?.file_details?.doc_reference_number);
      }
      setUploading(false);
    } catch (e) {
      setUploading(false);
      return null;
    }
  };

  const fetchS3URl = UploadedFile => {
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'eway_bill',
      transaction_id: transactionId,
      doc_reference_number: ewayNumber,
    };
    getTransactionsSignedURL(body, UploadedFile)
      .then(response => {
        const { url: signedURL, metadata } = response?.data;
        fileUploaderNew(signedURL, metadata, UploadedFile)
          .then(res => {
            if (res === 'success') {
              setTimeout(() => {
                fetchEwayUrl(token);
                setUploading(false);
                setEwayNumber('');
                setEwayFile(null);
              }, 5000);
            }
          })
          .catch(e => {
            setUploading(false);
            return null;
          });
      })
      .catch(e => {
        setUploading(false);
      });
  };
  const onDrop = async acceptedFiles => {
    // Do something with the files
    setUploading(true);
    fetchS3URl(acceptedFiles);
  };
  const viewFile = file => {
    if (!file) return;
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  };

  function viewFIleUploaded(podUrl) {
    window.open(podUrl);
  }

  async function deleteFIleUploaded() {
    setIsDeleting(true);
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'eway_bill',
      transaction_id: transactionId,
    };
    try {
      await deleteTransactionsFileHandler(body);
      setUploadedUrl('');
      fetchEwayUrl();
      setIsDeleting(false);
    } catch (e) {
      setIsDeleting(false);
    }
  }

  const handleGetEwayDetails = async () => {
    setLoadingEwayDetails(true);
    try {
      const endPoint = `pipe/ewaybill/details?transaction_id=${transactionId}`;
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const data = response?.data?.data;
      setEwayBillDetails(data);
      setLoadingEwayDetails(false);
    } catch (e) {
      logger.error(e);
      setLoadingEwayDetails(false);
    }
  };
  const handleEwayNumberUpdate = async () => {
    setUpdatingEwayNum(true);

    const endPoint = 'trips/v1/lr-eway-number';
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      transaction_id: transactionId,
      doc_type: 'eway_bill',
      doc_number: ewayNumber,
    };
    try {
      await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
      swal({
        title: 'Success!',
        text: `E-WAY Number Updated Successfully`,
        icon: 'success',
        timer: 3000,
      });
      fetchEwayUrl();
      setEwayNumber('');
      setUpdatingEwayNum(false);
    } catch (e) {
      setUpdatingEwayNum(false);
      swal({
        title: 'Error!',
        text: `Error While Updating E-WAY Number, Please Try Again!`,
        icon: 'error',
      });
    }
  };
  useEffect(() => {
    const currentUserDetails = myFirebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;
    setEwayNumber('');
    setToken(userToken);
    fetchEwayUrl();
  }, [activeRole, transactionId]);

  return (
    <>
      {currentTransactionData?.checkOne && currentTransactionData?.checkTwo ? (
        <Paper className={classes.paper}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h3
              className={`${stylesClass.classes.cardTitle} ${stylesClass.classes.rajdhaniFont}`}
              style={{ fontSize: '24px', textAlign: 'left' }}
            >
              E-Way Bill
            </h3>
            {fileDetails?.status === 'approved' && (
              <CheckCircleIcon style={inlineCheckIconStyle} />
            )}
            {(fileDetails?.status === 'pending' ||
              fileDetails?.status === 'rejected') && (
              <p
                style={{
                  color: '#363636',
                  backgroundColor: '#F1F2F4',
                  padding: '5px',
                  borderRadius: '8px',
                  margin: '0px 0px 0px 5px',
                }}
              >
                {fileDetails?.status}
              </p>
            )}
          </div>
          <div className={classes.ewayNumberContainer}>
            <InputLabel>E-Way Bill Number:</InputLabel>
            {(activeRole === 'branch-ops' ||
              activeRole === 'sales' ||
              activeRole === 'traffic') &&
            (!fileDetails?.doc_reference_number ||
              fileDetails?.status === 'rejected') ? (
              <Input
                value={ewayNumber}
                disabled={uploading}
                onChange={e => {
                  if (isEwayNumber(e.target.value)) {
                    setEwayNumber(e.target.value);
                  }
                }}
              />
            ) : (
              <div className={classes.ewayNumberContainer}>
                <h5 className={classes.ewayNumber}>
                  {fileDetails?.doc_reference_number || '–'}
                </h5>
                {fileDetails?.doc_reference_number && (
                  <Button
                    style={detailsButton}
                    onClick={() => {
                      handleGetEwayDetails();
                      setIsDialogOpen(true);
                    }}
                  >
                    Show Details
                  </Button>
                )}
              </div>
            )}
            {(activeRole === 'branch-ops' ||
              activeRole === 'sales' ||
              activeRole === 'traffic') &&
              ewayNumber?.length === 12 &&
              fileDetails?.status === 'approved' &&
              !fileDetails?.doc_reference_number && (
                <Button
                  className={classes.submitButton}
                  size="small"
                  variant="contained"
                  color="primary"
                  disabled={!ewayNumber || UpdatingEwayNum}
                  onClick={() => handleEwayNumberUpdate()}
                >
                  Save {UpdatingEwayNum && <CircularProgress size={8} />}
                </Button>
              )}
          </div>
          {featureFlagFiles === 0 || featureFlagFiles === 2 ? (
            <>
              {!uploadedURL ? (
                <div>
                  {activeRole === 'sales' ||
                  activeRole === 'branch-ops' ||
                  activeRole === 'traffic' ? (
                    <div>
                      {ewayFile ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '10px',
                          }}
                        >
                          <div>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => viewFile(ewayFile)}
                              className={classes.viewButton}
                              disabled={uploading}
                            >
                              View
                            </Button>
                            <IconButton
                              color="primary"
                              component="span"
                              size="small"
                              onClick={() => setEwayFile(null)}
                              disabled={uploading}
                            >
                              <DeleteOutlineIcon color="error" />
                            </IconButton>
                          </div>
                          <Button
                            size="small"
                            variant="contained"
                            className={classes.submitButton}
                            disabled={
                              ewayNumber?.length < 12 || !ewayFile || uploading
                            }
                            onClick={() => onDrop(ewayFile)}
                          >
                            Submit {uploading && <CircularProgress size={10} />}
                          </Button>
                        </div>
                      ) : (
                        <Dropzone
                          accept="image/png,image/jpeg,application/pdf"
                          maxFiles={1}
                          onDrop={acceptedFiles => {
                            if (!acceptedFiles.length) return;
                            setEwayFile(acceptedFiles[0]);
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              {...getRootProps()}
                              className={classes.container}
                            >
                              <input {...getInputProps()} />
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  flexDirection: 'column',
                                  marginTop: 5,
                                }}
                              >
                                {uploading ? (
                                  <CircularProgress />
                                ) : (
                                  <>
                                    <CloudUploadIcon />
                                    <p
                                      style={{
                                        fontSize: '10px',
                                        color: 'gray',
                                      }}
                                    >
                                      Drag and Drop or Click here to upload
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      )}
                    </div>
                  ) : (
                    <div className={classes.viewCard} style={{ margin: '0px' }}>
                      <p>No file uploaded</p>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className={classes.viewCard}>
                    <div className={classes.viewCardMeta}>
                      <p style={{ fontWeight: 'bold', margin: '0px' }}>
                        {fileDetails?.uploaded_by}
                      </p>
                      <p style={{ color: '#a9a9a9', fontSize: '12px' }}>
                        {moment(fileDetails?.updated_at).format('LLL')}
                      </p>
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        className={classes.viewButton}
                        onClick={() => viewFIleUploaded(uploadedURL)}
                        startIcon={<VisibilityIcon />}
                        // loading={fetching}
                      >
                        View
                      </Button>
                      {activeRole === 'ops' && (
                        <Popup
                          trigger={
                            isDeleting ? (
                              <CircularProgress
                                style={{ color: '#FCD21F', margin: '5px' }}
                                size={30}
                                thickness={8}
                              />
                            ) : (
                              <IconButton
                                color="primary"
                                aria-label="upload picture"
                                component="span"
                                disabled={fileDetails?.status !== 'approved'}
                              >
                                <DeleteOutlineIcon
                                  color={
                                    fileDetails?.status !== 'approved'
                                      ? ''
                                      : 'error'
                                  }
                                />
                              </IconButton>
                            )
                          }
                          {...{
                            contentStyle,
                          }}
                          modal
                        >
                          {close => (
                            <div
                              style={{
                                padding: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <HighlightOffIcon
                                fontSize="large"
                                color="error"
                              />

                              <h4 style={{ fontWeight: 'bold' }}>
                                Are You Sure?
                              </h4>
                              <p>
                                If you proceed, you will not be able to recover
                                it
                              </p>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  width: '100%',
                                }}
                              >
                                <Button
                                  onClick={close}
                                  className={classes.cancelButton}
                                >
                                  No
                                </Button>

                                <Button
                                  onClick={() => {
                                    close();
                                    deleteFIleUploaded();
                                  }}
                                  className={classes.deleteModalButton}
                                >
                                  Yes
                                </Button>
                              </div>
                            </div>
                          )}
                        </Popup>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : featureFlagFiles === 1 ? (
            <FeatureFlagEmptyState color="black" />
          ) : null}
          {fileDetails?.rejection_remarks &&
            fileDetails?.status === 'rejected' &&
            !ewayFile && (
              <Typography className={classes.rejectRemarks}>
                Reject Remarks: {fileDetails?.rejection_remarks}
              </Typography>
            )}
          <Dialog
            open={isDialogOpen}
            PaperProps={{
              style: {
                width: '500px',
                maxWidth: '500px',
              },
            }}
            fullWidth
            onClose={() => setIsDialogOpen(false)}
          >
            <DialogTitle>E-Way Bill Details</DialogTitle>
            <DialogContent>
              {loadingEwayDetails && <CircularProgress size={20} />}
              {ewayBillDetails && !loadingEwayDetails && (
                <Box display="flex" style={{ gap: '70px' }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    style={{ gap: '10px', color: '#4B5563' }}
                  >
                    <Typography variant="body1">E-Way Bill Number</Typography>
                    <Typography variant="body1">E-Way Date</Typography>
                    <Typography variant="body1">From City</Typography>
                    <Typography variant="body1">To City</Typography>
                    <Typography variant="body1">Vehicle Number</Typography>
                    <Typography variant="body1">Status</Typography>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    style={{ gap: '10px' }}
                  >
                    <Typography variant="body1">
                      {ewayBillDetails.bill_number || '-'}
                    </Typography>
                    <Typography variant="body1">
                      {ewayBillDetails.date || '-'}
                    </Typography>
                    <Typography variant="body1">
                      {ewayBillDetails.from_city || '-'}
                    </Typography>
                    <Typography variant="body1">
                      {ewayBillDetails.to_city || '-'}
                    </Typography>
                    <Typography variant="body1">
                      {ewayBillDetails.vehicle_number || '-'}
                    </Typography>
                    <Typography variant="body1">
                      {ewayBillDetails.status || '-'}
                    </Typography>
                  </Box>
                </Box>
              )}
              {!ewayBillDetails && !loadingEwayDetails && (
                <Typography variant="body1">No details available.</Typography>
              )}
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => setIsDialogOpen(false)}
                variant="contained"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Paper>
      ) : null}
    </>
  );
};

export default EwayBillUpload;
